export var HydraResponseKeys;
(function (HydraResponseKeys) {
    HydraResponseKeys["context"] = "@context";
    HydraResponseKeys["type"] = "@type";
    HydraResponseKeys["description"] = "hydra:description";
    HydraResponseKeys["title"] = "hydra:title";
    HydraResponseKeys["detail"] = "detail";
    HydraResponseKeys["violations"] = "violations";
})(HydraResponseKeys || (HydraResponseKeys = {}));
export var HydraResponseTypes;
(function (HydraResponseTypes) {
    HydraResponseTypes["collection"] = "hydra:Collection";
    HydraResponseTypes["error"] = "hydra:Error";
    HydraResponseTypes["violation"] = "ConstraintViolationList";
})(HydraResponseTypes || (HydraResponseTypes = {}));
